import SVG from 'react-inlinesvg';
import styled from '@emotion/styled';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const Wrapper = styled.span<{ isSmallScreen: boolean }>`
  display: inline-block;
  max-width: ${({ isSmallScreen }) => (isSmallScreen ? '180px' : '200px')};
  font-size: 0;

  svg {
    height: ${({ isSmallScreen }) => (isSmallScreen ? '30px' : '40px')};
    max-height: 100%;
    width: auto;
  }
`;

function Logo() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Wrapper isSmallScreen={isSmallScreen}>
      <SVG src="/media/brand/logo.svg" />
    </Wrapper>
  );
}

export default Logo;
